import { TrackingTrackingModelsAnalyticsDownloadDailySummary } from "melco-shared-logic";
import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { UserDownloadDetailList } from "../../UserDownloadDetailList";

type ReportDownloadDetailDrawerProps = {
  isDrawerOpen: boolean;
  setDrawerOpen: (isDrawerOpen: boolean) => void;
  selectedRowType: string;
  selectedUserId: string;
  selectedRowProductCode: string;
  reportsRawData:
  | TrackingTrackingModelsAnalyticsDownloadDailySummary[]
  | undefined;
};

export const ReportDownloadDetailDrawer: React.FC<
  ReportDownloadDetailDrawerProps
> = ({
  selectedRowProductCode,
  selectedRowType,
  isDrawerOpen,
  setDrawerOpen,
  selectedUserId,
  reportsRawData,
}) => {
    const { t } = useTranslation();

    console.log(isDrawerOpen);
    return (
      <Drawer
        title={t("reports.detail_drawer.title")}
        placement="right"
        width={750}
        closable={true}
        onClose={() => setDrawerOpen(false)}
        open={isDrawerOpen}
        bodyStyle={{ padding: "32px" }}
      >
        <UserDownloadDetailList
          selectedUserId={selectedUserId}
          selectedRowProductCode={selectedRowProductCode}
          reportsRawData={reportsRawData}
          selectedRowType={selectedRowType}
        />
      </Drawer>
    );
  };
